import { FormState } from '../../models';
import { basicInfo } from './basic-info';
import { configureAlarms } from './alarms';
import { dataDelivery } from './data-delivery';
import { dialogActions } from './dialog-actions';
import { ForesiteULLocationCardState } from './models';

/**
 * Foresite form configuration
 */
export const foresiteULFormState = (state: ForesiteULLocationCardState): FormState => {
    return {
        config: {
            info: {
                id: 'foresite-location-config',
                title: 'Foresite Location Configuration',
            },
            sections: [
                basicInfo(state),
                configureAlarms(state),
                dataDelivery(state),

                dialogActions(state),
            ],
        },
        pristine: true,
        valid: false,
        submitted: false,
    };
}
